// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_customTabs__SSb2Y {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  background-color: var(--table-header-bg);
  padding: 0.25rem;
  border-radius: 12px;
  width: -moz-fit-content;
  width: fit-content;
}

.style_tabButton__RBiV- {
  padding: 0.75rem 1.5rem;
  border: none;
  background-color: transparent;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;

  @media (max-width: 400px) {
    padding: 0.75rem 1rem;
  }
}

.style_tabButton__RBiV-:hover {
  color: var(--text-primary);
}

.style_activeTab__ca9FO {
  background: #ffffff;
  color: #007aff;
  border: 1px solid var(--table-border);
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomTabs/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;;EAEpB;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC","sourcesContent":[".customTabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  background-color: var(--table-header-bg);\n  padding: 0.25rem;\n  border-radius: 12px;\n  width: fit-content;\n}\n\n.tabButton {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background-color: transparent;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s;\n\n  @media (max-width: 400px) {\n    padding: 0.75rem 1rem;\n  }\n}\n\n.tabButton:hover {\n  color: var(--text-primary);\n}\n\n.activeTab {\n  background: #ffffff;\n  color: #007aff;\n  border: 1px solid var(--table-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customTabs": `style_customTabs__SSb2Y`,
	"tabButton": `style_tabButton__RBiV-`,
	"activeTab": `style_activeTab__ca9FO`
};
export default ___CSS_LOADER_EXPORT___;
